import { JsonObject, JsonProperty } from 'json2typescript';
import { SearchParams } from '../searchParams';
import { SearchResults } from '../searchResults';
import { Service } from './service';

@JsonObject('ServiceSearchResults')
export class ServiceSearchResults extends SearchResults {
    @JsonProperty('results', [Service])
    results: Service[] = [];
}

@JsonObject('ServiceSearchParams')
export class ServiceSearchParams extends SearchParams {
    @JsonProperty('level', Number, true)
    level: number = undefined;
}